import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AppThemeProvider, useAppTheme } from './theme/ThemeContext'
import { AuthProvider } from './auth/AuthContext'
import './index.css'
import App from './App'
import 'leaflet/dist/leaflet.css'
import 'leaflet-draw/dist/leaflet.draw.css'
import { LicenseInfo } from '@mui/x-license'

// Register axios interceptors (handles 401 redirects, etc.)
import './services/axiosConfig'
import './i18n'

const queryClient = new QueryClient()

LicenseInfo.setLicenseKey(import.meta.env.VITE_DATA_GRID_KEY)

const ThemedApp = () => {
  const { theme } = useAppTheme()

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppThemeProvider>
        <AuthProvider>
          <ThemedApp />
        </AuthProvider>
      </AppThemeProvider>
    </QueryClientProvider>
  </StrictMode>
)

